import { createFileRoute } from '@tanstack/react-router';
import { EnvironmentList } from '@/components/environments';

export const Route = createFileRoute('/_dashboard/environments/')({
  component: EnvironmentsPage,
});

function EnvironmentsPage() {
  return <EnvironmentList />;
}
